import {
  LookupAction,
  LOAD_GROUPS_SUCCESS,
  LOAD_GROUPS_FAIL,
} from "./actionTypes";

interface LookupsState {
  groups_loaded: boolean;
  error: null | string;
  groups?: any; // TODO: What is this?
  roles: {
    [key: string]: string;
  };
}

const initialState: LookupsState = {
  groups_loaded: false,
  error: null,
  roles: {
    Users: "Users",
    "ReadOnlyUsers": "ReadOnlyUsers",
    "Project Admins": "Project Admins",
    "Engineering Admins": "Engineering Admins",
    Administrators: "Administrators",
  },
};

export function reducer(
  state = initialState,
  action: LookupAction
): LookupsState {
  switch (action.type) {
    case LOAD_GROUPS_SUCCESS:
      return {
        ...state,
        groups: action.result,
        groups_loaded: true,
        error: null,
      };
    case LOAD_GROUPS_FAIL:
      return {
        ...state,
        groups_loaded: false,
        error: action.error.message || action.error.error,
      };
    default:
      return state;
  }
}
